import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type RouterService from '@/services/route/routerService'
import type TeamWorkflowService from '@/services/domain/accounts/teamWorkflowService'
import type { Route } from '@/services/route/types'
import { privacyPolicyBaseRouteName, privacyPolicyRouteName } from '@/routes/privacyPolicy'

// Forces terms acceptance on init, without interrupting flows.
@injectable()
export default class TermsUpdateResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.RouterService) private readonly routerService: RouterService,
    @inject(SERVICE_TYPES.TeamWorkflowService) private readonly teamWorkflowService: TeamWorkflowService,
  ) {}

  public async resolve() {
    const current = this.routerService.getCurrentRoute()
    if (this.teamWorkflowService.mustAcceptTermsUpdate() && !this.isAcceptPage(current)) {
      await this.routerService.replace({ name: privacyPolicyRouteName })
    }
  }

  private isAcceptPage(route: Route): boolean {
    return route.matched.some((record) => record.name === privacyPolicyBaseRouteName)
  }
}
